import { render, staticRenderFns } from "./EmployeeTabs.vue?vue&type=template&id=c17ed550&scoped=true"
import script from "./EmployeeTabs.vue?vue&type=script&lang=js"
export * from "./EmployeeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17ed550",
  null
  
)

export default component.exports